export const SET_PAYMENT_DATE = (state, value) => {
  state.selectedPaymentData.paymentDate = value
}

export const SET_AMOUNT = (state, value) => {
  state.selectedPaymentData.amount = value
}

export const SET_PAYMENT_METHOD = (state, value) => {
  state.selectedPaymentData.paymentMethod = value
}

export const SET_IBAN_DEBITED = (state, value) => {
  state.selectedPaymentData.ibanDebited = value
}

export const SET_IBAN_CREDITED = (state, value) => {
  state.selectedPaymentData.ibanCredited = value
}

export const SET_LIST = (state, value) => {
  state.list = value
}

export const SET_SELECTED_KEY = (state, value) => {
  state.selectedKey = value
}

export const setSelectedPaymentData = (state, value) => {
  let selectedPaymentData = { ..._getDocumentByKey(value, state) }
  state.selectedPaymentData = selectedPaymentData
  state.selectedKey = value
}

const _getDocumentByKey = (key, state) => {
  return state.list.find(paymentData => paymentData.key === key)
}

export const deletePayment = (state, value) => {
  state.list = state.list.filter(payment => payment.key !== value.key)
}

export const ADD = (state, value) => {
  state.list.push(value)
}
